import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { Button, Container, Filter, Table } from "components/ui";
import { useNavigate } from "react-router-dom";
import useProgramsContext from "../services/programsContext";
import { IProgramsFilter } from "common/types/programs";

const Programs = () => {
  const navigate = useNavigate();
  const {
    state: { filterFields, columns, data, loading, total },
    actions: { onRowClick },
  } = useProgramsContext();
  return (
    <div>
      <Row>
        <Col xs={18} md={6}>
          <Button
            type="primary"
            style={{ backgroundColor: "dodgerblue" }}
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => navigate("/programs/create")}
          >
            Dastur qo'shish
          </Button>
        </Col>
        <Col xs={6} md={18}>
          <Filter<IProgramsFilter>
            filterFields={filterFields}
            onFinish={(values) => {
              console.log(values);
            }}
          />
        </Col>
      </Row>
      <Container padding={false} filter>
        <Table
          columns={columns}
          dataSource={data}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => onRowClick(record, rowIndex), // click row
              style: { cursor: "pointer" },
            };
          }}
          loading={loading}
          total={total}
        />
      </Container>
    </div>
  );
};

export default Programs;
